import React from "react";
import CoursePestanasNav from "../components/CoursePestanasNav";
import "./Temario.css";

function Informacion() {
  return (
    <div className="cds-campus-root">
      <CoursePestanasNav />
      <h2>Sección: Información</h2>
      <p>Detalles generales o noticias para el usuario.</p>
    </div>
  );
}

export default Informacion;
